var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { onLongTouch } from './slotUtils';
import TennisGameWinnerOutcome from '../outcomes/TennisGameWinnerOutcome';
import Tappable from 'react-tappable';
import * as languageIds from '../../../../constants/Language';
import { byIdComparator } from './slotUtils';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            sectionToggled: true
        };
        _this.onClick = function () {
            _this.setState({
                sectionToggled: !_this.state.sectionToggled
            });
        };
        _this.onLongTouchClick = function () {
            onLongTouch(_this.props.slot, _this.props.match);
        };
        return _this;
    }
    default_1.prototype.render = function () {
        var _a = this.props, outcomes = _a.outcomes, gridLocalization = _a.gridLocalization, section = _a.section, languageId = _a.languageId;
        var sectionToggled = this.state.sectionToggled;
        var sectionCls = sectionToggled ? 'section selected' : 'section';
        var renderOutcomes = [];
        var props = {
            gridLocalization: gridLocalization,
            section: section
        };
        outcomes.sort(byIdComparator).map(function (outcome) {
            renderOutcomes.push(_jsx(TennisGameWinnerOutcome, __assign({ outcome: outcome }, props), outcome.get('id')));
        });
        var title = languageId === languageIds.RU ? 'Победа в указанном гейме' : 'WINNER OF SPECIFIED GAME';
        return (_jsxs("div", __assign({ className: sectionCls }, { children: [_jsxs(Tappable, __assign({ className: 'title toggle tappable-header', onClick: this.onClick, onPress: this.onLongTouchClick, stopPropagation: true }, { children: [_jsx("div", __assign({ className: 'name' }, { children: title })), " "] })), sectionToggled && _jsx("div", __assign({ className: 'items toggle_content' }, { children: renderOutcomes }))] })));
    };
    default_1.propTypes = {
        outcomes: PropTypes.object.isRequired,
        gridLocalization: PropTypes.object.isRequired,
        slot: PropTypes.object.isRequired,
        slotName: PropTypes.string,
        match: PropTypes.object.isRequired,
        section: PropTypes.string.isRequired,
        expanded: PropTypes.bool.isRequired
    };
    return default_1;
}(React.Component));
export default default_1;



// WEBPACK FOOTER //
// ./src/components/grid/event/slots/TennisGameWinnerSlot.jsx